module.exports = __webpack_public_path__ + "static/media/7.80756530.png";